































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Garden, Plants, ZoneNames, BorderNames } from "./types";

import { className, titleCase } from "@/utilities";

interface RouteElement {
  name: string;
  link?: string;
}
@Component
export default class App extends Vue {
  changeMeta(title: string, keywords?: string) {
    document.title = `Kruisbergse Tuin: ${titleCase(title)}`;
    const tag =
      document.querySelector("meta[name='keywords']") ||
      document.createElement("meta");
    tag.setAttribute("name", "keywords");
    if (keywords) {
      tag.setAttribute("content", `Tuin, Planten, Garden, Plants, ${keywords}`);
    } else {
      tag.setAttribute("content", "Tuin, Planten, Garden, Plants");
    }
    tag.setAttribute("data-vue-router-controlled", "");
    document.head.appendChild(tag);
  }

  @Watch("$route", { immediate: true, deep: true })
  routeChanged(to: any, from: any) {
    this.$ga.page(this.$route.path);
  }

  get up() {
    return this.$store.state.navigation.up;
  }

  get next() {
    return this.$store.state.navigation.next;
  }

  get prev() {
    return this.$store.state.navigation.prev;
  }
}
